
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import slackBot from "slack/slackBot.js";

import { isMaintenanceMode, checkIfMaintenanceModeProps } from "modules/utils";

// core components

import { PageSeo } from "seo-modules/PageSeo";

import RootProductsBody from "pages-sections/products-root/RootProductsBody";

const CategoriesPage = (props) => {
  if (isMaintenanceMode) {
    return <div />;
  }
  const { seo } = props;

  // if it's a root product page it returns pageData so let's render that...
  return (
    <>
      <PageSeo seo={seo} />
      <RootProductsBody {...props} />
    </>
  );
};
 async function _getStaticProps({ locale: lang }) {
  const maintenanceModeProps = checkIfMaintenanceModeProps();

  if (maintenanceModeProps) {
    return maintenanceModeProps;
  }

  // If not, it's a basic (root) page:
  try {
    const { default: rootProductsFetcher } = await import(
      "modules/products/rootProductsFetcher"
    );

    const categoryWhereArgs = {
      hideEmpty: true,
      orderby: "COUNT",
      order: "DESC",
    };

    return rootProductsFetcher(null, categoryWhereArgs, null, null, lang, null);
  } catch (error) {
    slackBot("[Build] | Caught error on Categories page", "error", error);

    console.error(error);

    // NB assumes all errors in GSP must be missing paths and redirects to 404:

    return { notFound: true };
  }
}

export default CategoriesPage;


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/categories',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  